import {AuthService, OrderService, EcomTrackingService} from 'hasta-la-vista-middleware-api/service'
export default {

    data(){
        return {
            loading: true,
            user: {FullName: null, Email: null, MobilePhone: null},
            order: {},
            saveUserData: false,
            saveNewsLetter: false,
            eft: false,
            leaveSite: false,
            isGuest: true,
            tmpEmail: null,
            originalEmail: null,
            confirmEmail: undefined,
            facebookPixelSKShow: false,
        }
    },

    methods: {
        checkPayment(){
            if (this.order.totalInCents == 0) {
                this.makePayment();
            } else {
                this.leaveSite = true;
            }
        },
        makePayment() {
            console.log(this.order);
            let EFT = this.eft;
            this.leaveSite = false
            this.loading = true;
            if (this.saveUserData) {
                AuthService.storeLocalUserOrderInfo(this.user)
            }
            else if (this.user.isTemp) {
                AuthService.storeLocalUserOrderInfo(this.user, true)
            }
            else {
                console.log("not saving User Data", this.user);
            }
          OrderService.makePayment(EFT,this.user);
        },
        facebookPixelSK() {
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '700460340621505');
            fbq('track', 'PageView');

            this.facebookPixelSKShow = true
        },
    },

    created(){
        this.loading = true;
        Promise.all([AuthService.getUserOrderInfo(), OrderService.getOrder(), AuthService.isGuestUser(), EcomTrackingService.doCheckoutBasketStepTwo()]).then(([userData,order, guest])=> {
            if (userData) this.user = userData
            this.isGuest = guest
            this.order = order;
            console.log(this.order);
            this.facebookPixelSK();
            this.loading = false;

        })
    },

    watch: {
        tmpEmail() {
            this.user.Email = this.originalEmail
            if(this.user.Email != this.tmpEmail) {
                this.confirmEmail = false
            } else {
                this.confirmEmail = true
            }
        },

        originalEmail() {
            this.user.Email = this.originalEmail
            if(this.user.Email != this.tmpEmail) {
                this.confirmEmail = false
            } else {
                this.confirmEmail = true
            }
        }
    },
    mounted(){
        window.scroll({top: 0, left: 0})
    },
}


// WEBPACK FOOTER //
// ./src/components/booking/checkout/checkout.js